// import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   FormControl,
//   Select,
//   MenuItem,
//   Tabs,
//   Tab,
//   CircularProgress,
//   ToggleButtonGroup,
//   ToggleButton,
//   Paper,
//   Popper,
//   Grow,
//   ClickAwayListener,
//   MenuList,
// } from "@mui/material";
// import ViewDayIcon from "@mui/icons-material/ViewDay";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// import PaymentIcon from "@mui/icons-material/Payment";
// import FeedbackIcon from "@mui/icons-material/Feedback";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import PersonIcon from "@mui/icons-material/Person";
// import EventNoteIcon from "@mui/icons-material/EventNote";
// import BadgeIcon from "@mui/icons-material/Badge";
// import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
// import MapIcon from "@mui/icons-material/Map";
// import DescriptionIcon from "@mui/icons-material/Description";
// import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import TravelSplash from "./TravelSplash";
// import DayWiseDashboard from "./DayWiseDashboard";
// import MonthlyDashboard from "./MonthlyDashboard";
// import TripEntryDashboard from "./TripEntryDashboard";
// import CustomerPaymentDashboard from "./CustomerPaymentDashboard";
// import CustomerFeedbackDashboard from "./CustomerFeedbackDashboard";
// import EnquiryDashboard from "./Enquirydashboard";
// import NotListedLocationRoundedIcon from "@mui/icons-material/NotListedLocationRounded";

// /* ---------- UNIFIED NAV ICON BOX ---------- */
// const NavIcon = ({ icon: Icon, active, color = "#0891b2" }) => (
//   <Box
//     sx={{
//       width: 36,
//       height: 36,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       bgcolor: active ? color : "#f0f0f0",
//       borderRadius: "50%",
//       transition: "all 0.15s ease-out",
//       transform: active ? "scale(1.15)" : "scale(1)",
//     }}
//   >
//     <Icon
//       sx={{
//         fontSize: 20,
//         color: active ? "#fff" : "#555",
//         transition: "color 0.15s",
//       }}
//     />
//   </Box>
// );

// const HoverGifIcon = ({ staticSrc, gifSrc, alt, active }) => {
//   return (
//     <img
//       src={active ? gifSrc : staticSrc}
//       alt={alt}
//       style={{
//         width: 42,
//         height: 42,
//         objectFit: "contain",
//         transform: active ? "scale(1)" : "scale(1)",
//         transition: "transform 0.15s ease-out",
//         pointerEvents: "none",
//         backgroundColor: "#F5F5F5",
//       }}
//     />
//   );
// };

// /* ---------- MONTH GENERATOR ---------- */
// const generateMonths = () => {
//   const months = [];
//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const currentMonth = currentDate.getMonth();

//   for (let i = 0; i < 12; i++) {
//     const date = new Date(currentYear, i, 1);
//     const monthStr = date.toLocaleString("default", { month: "short" });
//     months.push(`${monthStr} ${currentYear}`);
//   }

//   if (currentMonth < 6) {
//     const prevYearMonths = [];
//     for (let i = 6; i < 12; i++) {
//       const date = new Date(currentYear - 1, i, 1);
//       const monthStr = date.toLocaleString("default", { month: "short" });
//       prevYearMonths.push(`${monthStr} ${currentYear - 1}`);
//     }
//     months.unshift(...prevYearMonths);
//   }

//   if (currentMonth > 5) {
//     for (let i = 0; i < 6; i++) {
//       const date = new Date(currentYear + 1, i, 1);
//       const monthStr = date.toLocaleString("default", { month: "short" });
//       months.push(`${monthStr} ${currentYear + 1}`);
//     }
//   }

//   return months;
// };

// const getDaysInMonth = (monthYearStr) => {
//   const [monthStr, yearStr] = monthYearStr.split(" ");
//   const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
//   const year = parseInt(yearStr);
//   return new Date(year, monthIndex + 1, 0).getDate();
// };

// /* ---------- MASTERS DROPDOWN ITEMS ---------- */
// const masterItems = [
//   {
//     label: "Driver",
//     route: "/travel/driver-master",
//     icon: (active) => (
//       <HoverGifIcon
//         staticSrc={require("../../assets/icons/driver-master.png")}
//         gifSrc={require("../../assets/icons/driver-master.gif")}
//         alt="Driver"
//         active={active}
//       />
//     ),
//   },
//   {
//     label: "Vehicle",
//     route: "/travel/vehicle-master",
//     icon: (active) => (
//       <HoverGifIcon
//         staticSrc={require("../../assets/icons/vehicle-master.png")}
//         gifSrc={require("../../assets/icons/vehicle-master.gif")}
//         alt="Vehicle"
//         active={active}
//       />
//     ),
//   },
//   {
//     label: "Accounts",
//     route: "/accounts",
//     icon: (active) => (
//       <HoverGifIcon
//         staticSrc={require("../../assets/icons/accounts-master.png")}
//         gifSrc={require("../../assets/icons/accounts-master.gif")}
//         alt="Accounts"
//         active={active}
//       />
//     ),
//   },
//   {
//     label: "Itinerary",
//     route: "/travel/itinerary",
//     icon: (active) => (
//       <HoverGifIcon
//         staticSrc={require("../../assets/icons/itinerary-master.png")}
//         gifSrc={require("../../assets/icons/itinerary-master.gif")}
//         alt="Itinerary"
//         active={active}
//       />
//     ),
//   },
// ];

// /* ---------- MASTERS DROPDOWN COMPONENT ---------- */
// const MastersDropdown = ({ navigate, userDataObject }) => {
//   const [open, setOpen] = useState(false);
//   const [hoveredMaster, setHoveredMaster] = useState(null);
//   const anchorRef = useRef(null);

//   const handleToggle = () => setOpen((prev) => !prev);
//   const handleClose = () => setOpen(false);

//   return (
//     <Box sx={{ position: "relative" }}>
//       {/* Masters trigger card — same style as other nav items */}
//       <Box
//         ref={anchorRef}
//         onClick={handleToggle}
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           cursor: "pointer",
//           userSelect: "none",
//         }}
//       >
//         <Box
//           sx={{
//             width: 96,
//             height: 46,
//             borderRadius: 2,
//             bgcolor: open ? "#e8eaf6" : "#f5f5f5",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: open
//               ? "0px 8px 20px rgba(0,0,0,0.18)"
//               : "0px 2px 6px rgba(0,0,0,0.1)",
//             transition: "all 0.2s ease",
//           }}
//         >
//           <HoverGifIcon
//             staticSrc={require("../../assets/icons/departments.png")}
//             gifSrc={require("../../assets/icons/departments.gif")}
//             alt="Masters"
//             active={open}
//           />
//         </Box>
//         <Typography sx={{ mt: 0.25, fontWeight: 600, fontSize: 13 }}>
//           Masters
//         </Typography>
//         {/* Small chevron indicator */}
//         <Typography sx={{ fontSize: 9, color: "#888", lineHeight: 1 }}>
//           {open ? "▲" : "▼"}
//         </Typography>
//       </Box>

//       {/* Dropdown */}
//       <Popper
//         open={open}
//         anchorEl={anchorRef.current}
//         placement="bottom-end"
//         transition
//         disablePortal
//         style={{ zIndex: 1300 }}
//       >
//         {({ TransitionProps }) => (
//           <Grow {...TransitionProps} timeout={180}>
//             <Paper
//               elevation={6}
//               sx={{
//                 mt: 1,
//                 borderRadius: 2.5,
//                 overflow: "hidden",
//                 minWidth: 200,
//                 border: "1px solid #e8eaf6",
//               }}
//             >
//               <ClickAwayListener onClickAway={handleClose}>
//                 <MenuList disablePadding>
//                   {masterItems.map((item, idx) => (
//                     <Box
//                       key={item.label}
//                       onMouseEnter={() => setHoveredMaster(item.label)}
//                       onMouseLeave={() => setHoveredMaster(null)}
//                       onClick={() => {
//                         navigate(item.route, { state: userDataObject });
//                         handleClose();
//                       }}
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1.5,
//                         px: 2,
//                         py: 1,
//                         cursor: "pointer",
//                         bgcolor:
//                           hoveredMaster === item.label ? "#f0f4ff" : "#fff",
//                         borderBottom:
//                           idx < masterItems.length - 1
//                             ? "1px solid #f1f5f9"
//                             : "none",
//                         transition: "background-color 0.15s ease",
//                       }}
//                     >
//                       <Box sx={{ flexShrink: 0 }}>
//                         {item.icon(hoveredMaster === item.label)}
//                       </Box>
//                       <Typography
//                         sx={{
//                           fontWeight: hoveredMaster === item.label ? 700 : 500,
//                           fontSize: 14,
//                           color:
//                             hoveredMaster === item.label ? "#0891b2" : "#333",
//                           transition: "all 0.15s ease",
//                         }}
//                       >
//                         {item.label}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </MenuList>
//               </ClickAwayListener>
//             </Paper>
//           </Grow>
//         )}
//       </Popper>
//     </Box>
//   );
// };

// /* ---------- SESSION STORAGE KEY ---------- */
// const SELECTED_DATE_SESSION_KEY = "dashboard_selected_date";

// /* ================================================================
//    MAIN COMPONENT
//    ================================================================ */
// export default function DashboardHandler() {
//   const { userInfo } = useContext(AutoTaskAuthContext) || {};
//   const store_id = userInfo?.store_id;

//   const navigate = useNavigate();
//   const [hoveredKey, setHoveredKey] = useState(null);

//   const loggedUser = JSON.parse(localStorage.getItem("CapacitorStorage.user"));
//   const user_id = loggedUser?.id;
//   const user_mobile = loggedUser?.mobile;

//   const userDataObject = { user_id, user_mobile, store_id };

//   /* ---------- PAGE ROUTES ---------- */
//   const pageRoutes = [
//     {
//       label: "Bookings",
//       key: "bookings",
//       icon: (active) => (
//         <HoverGifIcon
//           staticSrc={require("../../assets/icons/booking-master.png")}
//           gifSrc={require("../../assets/icons/booking-master.gif")}
//           alt="Bookings"
//           active={active}
//         />
//       ),
//     },
//     {
//       label: "Customer",
//       key: "customerMaster",
//       screenRoute: "/travel/customer-master",
//       icon: (active) => (
//         <HoverGifIcon
//           staticSrc={require("../../assets/icons/customer-master.png")}
//           gifSrc={require("../../assets/icons/customer-master.gif")}
//           alt="Customer"
//           active={active}
//         />
//       ),
//     },
//     {
//       label: "Ledger Report",
//       key: "ledger-report",
//       screenRoute: "/accounts-ledger",
//       icon: (active) => (
//         <HoverGifIcon
//           staticSrc={require("../../assets/icons/ledger-report.png")}
//           gifSrc={require("../../assets/icons/ledger-report.gif")}
//           alt="Ledger Report"
//           active={active}
//         />
//       ),
//     },
//     {
//       label: "Voucher Entry",
//       key: "voucherEntry",
//       screenRoute: "/accounts-entry",
//       icon: (active) => (
//         <HoverGifIcon
//           staticSrc={require("../../assets/icons/voucher-entry.png")}
//           gifSrc={require("../../assets/icons/voucher-entry.gif")}
//           alt="Voucher Entry"
//           active={active}
//         />
//       ),
//     },
//     {
//       label: "Invoice",
//       key: "invoice",
//       screenRoute: "/invoice",
//       icon: (active) => (
//         <HoverGifIcon
//           staticSrc={require("../../assets/icons/invoice.png")}
//           gifSrc={require("../../assets/icons/invoice.gif")}
//           alt="Invoice"
//           active={active}
//         />
//       ),
//     },
//   ];

//   const [accountIds, setAccountIds] = useState();
//   const [searchParams] = useSearchParams();
//   const showSplashInitially = searchParams.get("splash") === "true";
//   const [showSplash, setShowSplash] = useState(showSplashInitially);
//   const [selectedMonth, setSelectedMonth] = useState(
//     `${new Date().toLocaleString("default", {
//       month: "short",
//     })} ${new Date().getFullYear()}`,
//   );
//   const [viewMode, setViewMode] = useState("day");
//   const [activeFilter, setActiveFilter] = useState("ALL");
//   const [vehiclesData, setVehiclesData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const getTomorrowDay = () => {
//     const d = new Date();
//     d.setDate(d.getDate() + 1);
//     return d.getDate();
//   };

//   /* ---------- selectedDate: restore from sessionStorage, fallback to tomorrow ---------- */
//   const getInitialSelectedDate = () => {
//     const stored = sessionStorage.getItem(SELECTED_DATE_SESSION_KEY);
//     if (stored !== null) {
//       const parsed = parseInt(stored, 10);
//       if (!isNaN(parsed)) return parsed;
//     }
//     return getTomorrowDay();
//   };

//   const [selectedDate, setSelectedDate] = useState(getInitialSelectedDate);

//   /* Persist selectedDate to sessionStorage whenever it changes */
//   const handleSetSelectedDate = (date) => {
//     setSelectedDate(date);
//     sessionStorage.setItem(SELECTED_DATE_SESSION_KEY, String(date));
//   };

//   const months = useMemo(() => generateMonths(), []);

//   useEffect(() => {
//     const maxDays = getDaysInMonth(selectedMonth);
//     if (selectedDate > maxDays) {
//       handleSetSelectedDate(maxDays);
//     }
//   }, [selectedMonth, selectedDate]);

//   const fetchBookings = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const [monthStr, yearStr] = selectedMonth.split(" ");
//       const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
//       const year = parseInt(yearStr);
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/travel/booking/dashboard/${store_id}`,
//         { month: monthIndex + 1, year },
//       );
//       if (response.data.success) {
//         setVehiclesData(response.data.data || []);
//       } else {
//         setError(response.data.statusMessage || "Failed to fetch bookings");
//       }
//     } catch {
//       setError("Network error. Please check your API connection.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAccountIds = async () => {
//     try {
//       const url = `${process.env.REACT_APP_API_BASE_URL}/api/accounts/get-account-numbers/${store_id}`;
//       const response = await axios.get(url);
//       setAccountIds(response.data.success ? response.data : null);
//     } catch {
//       setAccountIds(null);
//     }
//   };

//   useEffect(() => {
//     fetchBookings();
//     fetchAccountIds();
//   }, [selectedMonth]);

//   const filteredVehiclesData = useMemo(() => {
//     if (activeFilter === "ALL") return vehiclesData;
//     return vehiclesData.map((vehicle) => {
//       const filteredBookings = vehicle.bookings.filter((booking) => {
//         if (activeFilter === "CONFIRMED") return !booking.is_pending;
//         if (activeFilter === "PENDING") return booking.is_pending;
//         if (activeFilter === "BOOKING") return booking.type.includes("Booking");
//         if (activeFilter === "ENQUIRY") return booking.type.includes("Enquiry");
//         return true;
//       });
//       return { ...vehicle, bookings: filteredBookings };
//     });
//   }, [vehiclesData, activeFilter]);

//   const handleNavigateToBooking = (additionalState = {}) => {
//     const [monthStr, yearStr] = selectedMonth.split(" ");
//     const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
//     const year = parseInt(yearStr);
//     const formattedDate = `${String(selectedDate).padStart(2, "0")}-${String(
//       monthIndex + 1,
//     ).padStart(2, "0")}-${year}`;
//     navigate("/travel/booking", {
//       state: {
//         ...userDataObject,
//         selectedDate: formattedDate,
//         selectedMonth,
//         ...additionalState,
//       },
//     });
//   };

//   const handleNavClick = (page) => {
//     if (page.key === "bookings") {
//       handleNavigateToBooking();
//     } else {
//       navigate(page.screenRoute, { state: userDataObject });
//     }
//   };

//   return (
//     <>
//       {showSplash && <TravelSplash onFinish={() => setShowSplash(false)} />}

//       {!showSplash && (
//         <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//           {/* HEADER */}
//           <Box
//             sx={{
//               p: { xs: 0.75, sm: 1, md: 1.5 },
//               borderBottom: 1,
//               borderColor: "divider",
//               bgcolor: "background.paper",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "flex-start",
//                 flexWrap: "wrap",
//                 gap: 1.5,
//               }}
//             >
//               {/* LEFT */}
//               <Box>
//                 <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                   <ToggleButtonGroup
//                     value={viewMode}
//                     exclusive
//                     onChange={(e, v) => {
//                       if (v) {
//                         setViewMode(v);
//                         if (v !== "day" && activeFilter === "AVAILABLE") {
//                           setActiveFilter("ALL");
//                         }
//                       }
//                     }}
//                     size="small"
//                   >
//                     <ToggleButton value="tripEntry">
//                       <DirectionsCarIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Trip Entry
//                     </ToggleButton>
//                     <ToggleButton value="customerPayment">
//                       <PaymentIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Customer Payment
//                     </ToggleButton>
//                     <ToggleButton value="customerFeedback">
//                       <FeedbackIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Customer Feedback
//                     </ToggleButton>
//                     <ToggleButton value="day">
//                       <ViewDayIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Day View
//                     </ToggleButton>
//                     <ToggleButton value="month">
//                       <CalendarMonthIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Month View
//                     </ToggleButton>
//                     <ToggleButton value="enquiry">
//                       <NotListedLocationRoundedIcon
//                         sx={{ mr: 0.5, fontSize: 18 }}
//                       />
//                       Enquiries
//                     </ToggleButton>
//                   </ToggleButtonGroup>

//                   <FormControl size="small" sx={{ minWidth: 120 }}>
//                     <Select
//                       value={selectedMonth}
//                       onChange={(e) => setSelectedMonth(e.target.value)}
//                     >
//                       {months.map((m) => (
//                         <MenuItem key={m} value={m}>
//                           {m}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>

//                 {/* FILTER TABS */}
//                 {viewMode !== "enquiry" && (
//                   <Box sx={{ mt: 1 }}>
//                     <Tabs
//                       value={activeFilter}
//                       onChange={(e, v) => v && setActiveFilter(v)}
//                       variant="scrollable"
//                       scrollButtons="auto"
//                     >
//                       <Tab label="All" value="ALL" />
//                       <Tab label="Confirmed" value="CONFIRMED" />
//                       <Tab label="Pending" value="PENDING" />
//                       <Tab label="Bookings" value="BOOKING" />
//                       {viewMode === "day" && (
//                         <Tab label="Available Vehicles" value="AVAILABLE" />
//                       )}
//                     </Tabs>
//                   </Box>
//                 )}
//               </Box>

//               {/* RIGHT — nav icons */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "flex-end",
//                   gap: 1.5,
//                 }}
//               >
//                 <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
//                   {/* Direct nav items */}
//                   {pageRoutes.map((page) => {
//                     const isHovered = hoveredKey === page.key;
//                     return (
//                       <Box
//                         key={page.key}
//                         onMouseEnter={() => setHoveredKey(page.key)}
//                         onMouseLeave={() => setHoveredKey(null)}
//                         onClick={() => handleNavClick(page)}
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             width: 96,
//                             height: 46,
//                             borderRadius: 2,
//                             bgcolor: "#f5f5f5",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           {page.icon(isHovered)}
//                         </Box>
//                         <Typography
//                           sx={{
//                             mt: 0.25,
//                             fontWeight: 600,
//                             fontSize: 13,
//                             transform: isHovered ? "scale(0.9)" : "scale(1)",
//                             transition: "transform 0.2s ease",
//                           }}
//                         >
//                           {page.label}
//                         </Typography>
//                       </Box>
//                     );
//                   })}

//                   {/* Masters dropdown */}
//                   <MastersDropdown
//                     navigate={navigate}
//                     userDataObject={userDataObject}
//                   />
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           {/* BODY */}
//           {loading ? (
//             <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <Box sx={{ flex: 1, overflow: "hidden" }}>
//               {viewMode === "tripEntry" && (
//                 <TripEntryDashboard
//                   setSelectedMonth={setSelectedMonth}
//                   accountIds={accountIds}
//                   selectedMonth={selectedMonth}
//                   selectedDate={selectedDate}
//                   setSelectedDate={handleSetSelectedDate}
//                   activeFilter={activeFilter}
//                   vehiclesData={vehiclesData}
//                   onRefresh={fetchBookings}
//                   onNavigateToBooking={handleNavigateToBooking}
//                 />
//               )}
//               {viewMode === "customerPayment" && (
//                 <CustomerPaymentDashboard
//                   setSelectedMonth={setSelectedMonth}
//                   accountIds={accountIds}
//                   selectedMonth={selectedMonth}
//                   selectedDate={selectedDate}
//                   setSelectedDate={handleSetSelectedDate}
//                   activeFilter={activeFilter}
//                   vehiclesData={vehiclesData}
//                   onRefresh={fetchBookings}
//                   onNavigateToBooking={handleNavigateToBooking}
//                 />
//               )}
//               {viewMode === "customerFeedback" && (
//                 <CustomerFeedbackDashboard
//                   setSelectedMonth={setSelectedMonth}
//                   selectedMonth={selectedMonth}
//                   selectedDate={selectedDate}
//                   setSelectedDate={handleSetSelectedDate}
//                   activeFilter={activeFilter}
//                   vehiclesData={vehiclesData}
//                   onRefresh={fetchBookings}
//                   onNavigateToBooking={handleNavigateToBooking}
//                 />
//               )}
//               {viewMode === "day" && (
//                 <DayWiseDashboard
//                   setSelectedMonth={setSelectedMonth}
//                   selectedMonth={selectedMonth}
//                   selectedDate={selectedDate}
//                   setSelectedDate={handleSetSelectedDate}
//                   activeFilter={activeFilter}
//                   vehiclesData={filteredVehiclesData}
//                   onRefresh={fetchBookings}
//                   onNavigateToBooking={handleNavigateToBooking}
//                 />
//               )}
//               {viewMode === "month" && (
//                 <MonthlyDashboard
//                   selectedMonth={selectedMonth}
//                   activeFilter={activeFilter}
//                   vehiclesData={filteredVehiclesData}
//                   onRefresh={fetchBookings}
//                 />
//               )}
//               {viewMode === "enquiry" && (
//                 <EnquiryDashboard
//                   vehiclesData={vehiclesData}
//                   selectedMonth={selectedMonth}
//                   onRefresh={fetchBookings}
//                   onNavigateToBooking={handleNavigateToBooking}
//                 />
//               )}
//             </Box>
//           )}
//         </Box>
//       )}
//     </>
//   );
// }
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Paper,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  Tooltip,
} from "@mui/material";
import ViewDayIcon from "@mui/icons-material/ViewDay";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PaymentIcon from "@mui/icons-material/Payment";
import FeedbackIcon from "@mui/icons-material/Feedback";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import MapIcon from "@mui/icons-material/Map";
import DescriptionIcon from "@mui/icons-material/Description";
import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
import { useSearchParams, useNavigate } from "react-router-dom";
import TravelSplash from "./TravelSplash";
import DayWiseDashboard from "./DayWiseDashboard";
import MonthlyDashboard from "./MonthlyDashboard";
import TripEntryDashboard from "./TripEntryDashboard";
import CustomerPaymentDashboard from "./CustomerPaymentDashboard";
import CustomerFeedbackDashboard from "./CustomerFeedbackDashboard";
import EnquiryDashboard from "./Enquirydashboard";
import NotListedLocationRoundedIcon from "@mui/icons-material/NotListedLocationRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import LogoutConfirmDialog from "../LogoutConfirmDialog";

/* ---------- HOVER GIF ICON ---------- */
const HoverGifIcon = ({ staticSrc, gifSrc, alt, active, size = 26 }) => (
  <img
    src={active ? gifSrc : staticSrc}
    alt={alt}
    style={{
      width: size,
      height: size,
      objectFit: "contain",
      pointerEvents: "none",
      display: "block",
    }}
  />
);

/* ---------- MONTH GENERATOR (unchanged) ---------- */
const generateMonths = () => {
  const months = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  for (let i = 0; i < 12; i++) {
    const date = new Date(currentYear, i, 1);
    const monthStr = date.toLocaleString("default", { month: "short" });
    months.push(`${monthStr} ${currentYear}`);
  }

  if (currentMonth < 6) {
    const prevYearMonths = [];
    for (let i = 6; i < 12; i++) {
      const date = new Date(currentYear - 1, i, 1);
      const monthStr = date.toLocaleString("default", { month: "short" });
      prevYearMonths.push(`${monthStr} ${currentYear - 1}`);
    }
    months.unshift(...prevYearMonths);
  }

  if (currentMonth > 5) {
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentYear + 1, i, 1);
      const monthStr = date.toLocaleString("default", { month: "short" });
      months.push(`${monthStr} ${currentYear + 1}`);
    }
  }

  return months;
};

const getDaysInMonth = (monthYearStr) => {
  const [monthStr, yearStr] = monthYearStr.split(" ");
  const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
  const year = parseInt(yearStr);
  return new Date(year, monthIndex + 1, 0).getDate();
};

/* ---------- VIEW MODE CONFIG ---------- */
const VIEW_MODES = [
  { key: "tripEntry", label: "Trip", Icon: DirectionsCarIcon },
  { key: "customerPayment", label: "Payment", Icon: PaymentIcon },
  { key: "customerFeedback", label: "Feedback", Icon: FeedbackIcon },
  { key: "day", label: "Day", Icon: ViewDayIcon },
  { key: "month", label: "Month", Icon: CalendarMonthIcon },
  { key: "enquiry", label: "Enquiry", Icon: NotListedLocationRoundedIcon },
];

const FILTER_TABS_BASE = [
  { value: "ALL", label: "All" },
  { value: "CONFIRMED", label: "Confirmed" },
  { value: "PENDING", label: "Pending" },
  { value: "BOOKING", label: "Bookings" },
];

/* ---------- MASTERS DROPDOWN ITEMS (unchanged routes) ---------- */
const masterItems = [
  {
    label: "Driver",
    route: "/travel/driver-master",
    icon: (active) => (
      <HoverGifIcon
        staticSrc={require("../../assets/icons/driver-master.png")}
        gifSrc={require("../../assets/icons/driver-master.gif")}
        alt="Driver"
        active={active}
        size={22}
      />
    ),
  },
  {
    label: "Vehicle",
    route: "/travel/vehicle-master",
    icon: (active) => (
      <HoverGifIcon
        staticSrc={require("../../assets/icons/vehicle-master.png")}
        gifSrc={require("../../assets/icons/vehicle-master.gif")}
        alt="Vehicle"
        active={active}
        size={22}
      />
    ),
  },
  {
    label: "Accounts",
    route: "/accounts",
    icon: (active) => (
      <HoverGifIcon
        staticSrc={require("../../assets/icons/accounts-master.png")}
        gifSrc={require("../../assets/icons/accounts-master.gif")}
        alt="Accounts"
        active={active}
        size={22}
      />
    ),
  },
  {
    label: "Itinerary",
    route: "/travel/itinerary",
    icon: (active) => (
      <HoverGifIcon
        staticSrc={require("../../assets/icons/itinerary-master.png")}
        gifSrc={require("../../assets/icons/itinerary-master.gif")}
        alt="Itinerary"
        active={active}
        size={22}
      />
    ),
  },
];

/* ---- COMPACT MASTERS DROPDOWN ---- */
const MastersDropdown = ({ navigate, userDataObject }) => {
  const [open, setOpen] = useState(false);
  const [hoveredMaster, setHoveredMaster] = useState(null);
  const anchorRef = useRef(null);

  return (
    <Box sx={{ position: "relative", flexShrink: 0 }}>
      <Box
        ref={anchorRef}
        onClick={() => setOpen((p) => !p)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.6,
          height: 30,
          px: 1.2,
          borderRadius: 1.5,
          border: "0.5px solid",
          borderColor: open ? "primary.main" : "divider",
          bgcolor: open ? "primary.50" : "grey.50",
          cursor: "pointer",
          userSelect: "none",
          transition: "all 0.15s",
          "&:hover": { borderColor: "primary.main", bgcolor: "primary.50" },
        }}
      >
        <HoverGifIcon
          staticSrc={require("../../assets/icons/departments.png")}
          gifSrc={require("../../assets/icons/departments.gif")}
          alt="Masters"
          active={open}
          size={20}
        />
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            color: open ? "primary.main" : "text.secondary",
          }}
        >
          Masters
        </Typography>
        {open ? (
          <KeyboardArrowUpRoundedIcon
            sx={{ fontSize: 14, color: "primary.main" }}
          />
        ) : (
          <KeyboardArrowDownRoundedIcon
            sx={{ fontSize: 14, color: "text.secondary" }}
          />
        )}
      </Box>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={150}>
            <Paper
              elevation={4}
              sx={{
                mt: 0.5,
                borderRadius: 2,
                overflow: "hidden",
                minWidth: 170,
                border: "0.5px solid",
                borderColor: "divider",
              }}
            >
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList disablePadding>
                  {masterItems.map((item, idx) => (
                    <Box
                      key={item.label}
                      onMouseEnter={() => setHoveredMaster(item.label)}
                      onMouseLeave={() => setHoveredMaster(null)}
                      onClick={() => {
                        navigate(item.route, { state: userDataObject });
                        setOpen(false);
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.2,
                        px: 1.5,
                        py: 0.9,
                        cursor: "pointer",
                        bgcolor:
                          hoveredMaster === item.label
                            ? "primary.50"
                            : "background.paper",
                        borderBottom:
                          idx < masterItems.length - 1 ? "0.5px solid" : "none",
                        borderColor: "divider",
                        transition: "background 0.12s",
                      }}
                    >
                      {item.icon(hoveredMaster === item.label)}
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: hoveredMaster === item.label ? 600 : 500,
                          color:
                            hoveredMaster === item.label
                              ? "primary.main"
                              : "text.primary",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

/* ---------- SESSION STORAGE KEY ---------- */
const SELECTED_DATE_SESSION_KEY = "dashboard_selected_date";

/* ================================================================
   MAIN COMPONENT
   ================================================================ */
export default function DashboardHandler() {
  const { userInfo } = useContext(AutoTaskAuthContext) || {};
  const store_id = userInfo?.store_id;

  const navigate = useNavigate();
  const [hoveredKey, setHoveredKey] = useState(null);

  /* A travel store now opens straight onto this dashboard at login, so this
   * header is the whole session's chrome for most of its users — the way out
   * belongs here rather than only in the Daily Tick sidebar behind it. */
  const [logoutOpen, setLogoutOpen] = useState(false);

  const loggedUser = JSON.parse(localStorage.getItem("CapacitorStorage.user"));
  const user_id = loggedUser?.id;
  const user_mobile = loggedUser?.mobile;
  const userDataObject = { user_id, user_mobile, store_id };

  /* PAGE ROUTES (unchanged) */
  const pageRoutes = [
    {
      label: "Bookings",
      key: "bookings",
      icon: (active) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/booking-master.png")}
          gifSrc={require("../../assets/icons/booking-master.gif")}
          alt="Bookings"
          active={active}
          size={20}
        />
      ),
    },
    {
      label: "Customer",
      key: "customerMaster",
      screenRoute: "/travel/customer-master",
      icon: (active) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/customer-master.png")}
          gifSrc={require("../../assets/icons/customer-master.gif")}
          alt="Customer"
          active={active}
          size={20}
        />
      ),
    },
    {
      label: "Report",
      key: "ledger-report",
      screenRoute: "/accounts-ledger",
      icon: (active) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/ledger-report.png")}
          gifSrc={require("../../assets/icons/ledger-report.gif")}
          alt="Ledger Report"
          active={active}
          size={20}
        />
      ),
    },
    {
      label: "Voucher Entry",
      key: "voucherEntry",
      screenRoute: "/accounts-entry",
      icon: (active) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/voucher-entry.png")}
          gifSrc={require("../../assets/icons/voucher-entry.gif")}
          alt="Voucher Entry"
          active={active}
          size={20}
        />
      ),
    },
    {
      label: "Invoice",
      key: "invoice",
      screenRoute: "/invoice",
      icon: (active) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/invoice.png")}
          gifSrc={require("../../assets/icons/invoice.gif")}
          alt="Invoice"
          active={active}
          size={20}
        />
      ),
    },
  ];

  /* STATE (all unchanged) */
  const [accountIds, setAccountIds] = useState();
  const [searchParams] = useSearchParams();
  const showSplashInitially = searchParams.get("splash") === "true";
  const [showSplash, setShowSplash] = useState(showSplashInitially);
  const [selectedMonth, setSelectedMonth] = useState(
    `${new Date().toLocaleString("default", {
      month: "short",
    })} ${new Date().getFullYear()}`,
  );
  const [viewMode, setViewMode] = useState("day");
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [vehiclesData, setVehiclesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getTomorrowDay = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.getDate();
  };

  const getInitialSelectedDate = () => {
    const stored = sessionStorage.getItem(SELECTED_DATE_SESSION_KEY);
    if (stored !== null) {
      const parsed = parseInt(stored, 10);
      if (!isNaN(parsed)) return parsed;
    }
    return getTomorrowDay();
  };

  const [selectedDate, setSelectedDate] = useState(getInitialSelectedDate);

  const handleSetSelectedDate = (date) => {
    setSelectedDate(date);
    sessionStorage.setItem(SELECTED_DATE_SESSION_KEY, String(date));
  };

  const months = useMemo(() => generateMonths(), []);

  useEffect(() => {
    const maxDays = getDaysInMonth(selectedMonth);
    if (selectedDate > maxDays) handleSetSelectedDate(maxDays);
  }, [selectedMonth, selectedDate]);

  const fetchBookings = async () => {
    setLoading(true);
    setError(null);
    try {
      const [monthStr, yearStr] = selectedMonth.split(" ");
      const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
      const year = parseInt(yearStr);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/travel/booking/dashboard/${store_id}`,
        { month: monthIndex + 1, year },
      );
      if (response.data.success) setVehiclesData(response.data.data || []);
      else setError(response.data.statusMessage || "Failed to fetch bookings");
    } catch {
      setError("Network error. Please check your API connection.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountIds = async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/accounts/get-account-numbers/${store_id}`;
      const response = await axios.get(url);
      setAccountIds(response.data.success ? response.data : null);
    } catch {
      setAccountIds(null);
    }
  };

  useEffect(() => {
    fetchBookings();
    fetchAccountIds();
  }, [selectedMonth]);

  const filteredVehiclesData = useMemo(() => {
    if (activeFilter === "ALL") return vehiclesData;
    return vehiclesData.map((vehicle) => {
      const filteredBookings = vehicle.bookings.filter((booking) => {
        if (activeFilter === "CONFIRMED") return !booking.is_pending;
        if (activeFilter === "PENDING") return booking.is_pending;
        if (activeFilter === "BOOKING") return booking.type.includes("Booking");
        if (activeFilter === "ENQUIRY") return booking.type.includes("Enquiry");
        return true;
      });
      return { ...vehicle, bookings: filteredBookings };
    });
  }, [vehiclesData, activeFilter]);

  const handleNavigateToBooking = (additionalState = {}) => {
    const [monthStr, yearStr] = selectedMonth.split(" ");
    const monthIndex = new Date(`${monthStr} 1, ${yearStr}`).getMonth();
    const year = parseInt(yearStr);
    const formattedDate = `${String(selectedDate).padStart(2, "0")}-${String(
      monthIndex + 1,
    ).padStart(2, "0")}-${year}`;
    navigate("/travel/booking", {
      state: {
        ...userDataObject,
        selectedDate: formattedDate,
        selectedMonth,
        ...additionalState,
      },
    });
  };

  const handleNavClick = (page) => {
    if (page.key === "bookings") handleNavigateToBooking();
    else navigate(page.screenRoute, { state: userDataObject });
  };

  /* ---- filter tabs (show AVAILABLE only in day view) ---- */
  const filterTabs =
    viewMode === "day"
      ? [...FILTER_TABS_BASE, { value: "AVAILABLE", label: "Available" }]
      : FILTER_TABS_BASE;

  /* ------------------------------------------------------------------ */
  return (
    <>
      {showSplash && <TravelSplash onFinish={() => setShowSplash(false)} />}

      {!showSplash && (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
          {/* ═══════════════════════════════════
              COMPACT SINGLE-ROW HEADER  ~50px
          ═══════════════════════════════════ */}
          <Box
            sx={{
              height: 50,
              minHeight: 50,
              px: 1.5,
              borderBottom: "0.5px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              display: "flex",
              alignItems: "center",
              gap: 1,
              overflow: "visible",
              position: "relative",
              zIndex: 100,
            }}
          >
            {/* LEFT: view-mode toggle pill */}
            <Box
              sx={{
                display: "flex",
                flexShrink: 0,
                border: "0.5px solid",
                borderColor: "divider",
                borderRadius: 1.5,
                overflow: "hidden",
                height: 30,
              }}
            >
              {VIEW_MODES.map(({ key, label, Icon }) => {
                const active = viewMode === key;
                return (
                  <Box
                    key={key}
                    onClick={() => {
                      setViewMode(key);
                      if (key !== "day" && activeFilter === "AVAILABLE")
                        setActiveFilter("ALL");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      px: 1.1,
                      cursor: "pointer",
                      bgcolor: active ? "#0891b2" : "grey.50",
                      borderRight: "0.5px solid",
                      borderColor: "divider",
                      transition: "all 0.12s",
                      "&:last-child": { borderRight: "none" },
                      "&:hover": { bgcolor: active ? "#0891b2" : "grey.100" },
                    }}
                  >
                    <Icon
                      sx={{
                        fontSize: 14,
                        color: active ? "#fff" : "text.secondary",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 11.5,
                        fontWeight: 600,
                        color: active ? "#fff" : "text.secondary",
                        lineHeight: 1,
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            {/* DIVIDER */}
            <Box
              sx={{
                width: "0.5px",
                height: 28,
                bgcolor: "divider",
                flexShrink: 0,
              }}
            />

            {/* CENTER: filter tabs (hidden for enquiry) */}
            {viewMode !== "enquiry" && (
              <Box
                sx={{
                  display: "flex",
                  gap: 0.4,
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                {filterTabs.map(({ value, label }) => {
                  const active = activeFilter === value;
                  return (
                    <Box
                      key={value}
                      onClick={() => setActiveFilter(value)}
                      sx={{
                        height: 24,
                        px: 1.1,
                        borderRadius: 20,
                        cursor: "pointer",
                        border: "0.5px solid",
                        borderColor: active ? "#bae6fd" : "transparent",
                        bgcolor: active ? "#e0f2fe" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        transition: "all 0.12s",
                        "&:hover": { bgcolor: active ? "#e0f2fe" : "grey.100" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 11.5,
                          fontWeight: 600,
                          color: active ? "#0369a1" : "text.secondary",
                          lineHeight: 1,
                        }}
                      >
                        {label}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            )}

            {/* DIVIDER */}
            {viewMode !== "enquiry" && (
              <Box
                sx={{
                  width: "0.5px",
                  height: 28,
                  bgcolor: "divider",
                  flexShrink: 0,
                }}
              />
            )}

            {/* MONTH SELECT */}
            <FormControl size="small" sx={{ flexShrink: 0 }}>
              <Select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                sx={{
                  height: 30,
                  fontSize: 12,
                  fontWeight: 600,
                  "& .MuiSelect-select": {
                    py: 0,
                    px: 1.2,
                    display: "flex",
                    alignItems: "center",
                  },
                  "& fieldset": { borderColor: "divider !important" },
                  minWidth: 100,
                }}
              >
                {months.map((m) => (
                  <MenuItem key={m} value={m} sx={{ fontSize: 12 }}>
                    {m}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* SPACER */}
            <Box sx={{ flex: 1 }} />

            {/* RIGHT: nav icon buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 0.6,
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              {pageRoutes.map((page) => {
                const isHovered = hoveredKey === page.key;
                return (
                  <Tooltip
                    key={page.key}
                    title={page.label}
                    placement="bottom"
                    arrow
                  >
                    <Box
                      onMouseEnter={() => setHoveredKey(page.key)}
                      onMouseLeave={() => setHoveredKey(null)}
                      onClick={() => handleNavClick(page)}
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 1.5,
                        border: "0.5px solid",
                        borderColor: isHovered ? "primary.main" : "divider",
                        bgcolor: isHovered ? "primary.50" : "grey.50",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.12s",
                        flexShrink: 0,
                      }}
                    >
                      {page.icon(isHovered)}
                    </Box>
                  </Tooltip>
                );
              })}

              {/* thin divider before masters */}
              <Box
                sx={{
                  width: "0.5px",
                  height: 28,
                  bgcolor: "divider",
                  mx: 0.4,
                  flexShrink: 0,
                }}
              />

              <MastersDropdown
                navigate={navigate}
                userDataObject={userDataObject}
              />

              {/* thin divider before the session control */}
              <Box
                sx={{
                  width: "0.5px",
                  height: 28,
                  bgcolor: "divider",
                  mx: 0.4,
                  flexShrink: 0,
                }}
              />

              {/* LOG OUT — same hover-GIF tile as the nav icons, tinted red so
                  it doesn't read as one more place to navigate to. */}
              <Tooltip title="Log out" placement="bottom" arrow>
                <Box
                  onMouseEnter={() => setHoveredKey("logout")}
                  onMouseLeave={() => setHoveredKey(null)}
                  onClick={() => setLogoutOpen(true)}
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1.5,
                    border: "0.5px solid",
                    borderColor:
                      hoveredKey === "logout" ? "#DC2626" : "divider",
                    bgcolor:
                      hoveredKey === "logout"
                        ? "rgba(220,38,38,0.08)"
                        : "grey.50",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.12s",
                    flexShrink: 0,
                  }}
                >
                  <HoverGifIcon
                    staticSrc={require("../../assets/icons/logout.png")}
                    gifSrc={require("../../assets/icons/logout.gif")}
                    alt="Log out"
                    active={hoveredKey === "logout"}
                    size={20}
                  />
                </Box>
              </Tooltip>
            </Box>
          </Box>
          {/* ═══════════════════════════════════ */}

          {/* BODY */}
          {loading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Box sx={{ flex: 1, overflow: "hidden" }}>
              {viewMode === "tripEntry" && (
                <TripEntryDashboard
                  setSelectedMonth={setSelectedMonth}
                  accountIds={accountIds}
                  selectedMonth={selectedMonth}
                  selectedDate={selectedDate}
                  setSelectedDate={handleSetSelectedDate}
                  activeFilter={activeFilter}
                  vehiclesData={vehiclesData}
                  onRefresh={fetchBookings}
                  onNavigateToBooking={handleNavigateToBooking}
                />
              )}
              {viewMode === "customerPayment" && (
                <CustomerPaymentDashboard
                  setSelectedMonth={setSelectedMonth}
                  accountIds={accountIds}
                  selectedMonth={selectedMonth}
                  selectedDate={selectedDate}
                  setSelectedDate={handleSetSelectedDate}
                  activeFilter={activeFilter}
                  vehiclesData={vehiclesData}
                  onRefresh={fetchBookings}
                  onNavigateToBooking={handleNavigateToBooking}
                />
              )}
              {viewMode === "customerFeedback" && (
                <CustomerFeedbackDashboard
                  setSelectedMonth={setSelectedMonth}
                  selectedMonth={selectedMonth}
                  selectedDate={selectedDate}
                  setSelectedDate={handleSetSelectedDate}
                  activeFilter={activeFilter}
                  vehiclesData={vehiclesData}
                  onRefresh={fetchBookings}
                  onNavigateToBooking={handleNavigateToBooking}
                />
              )}
              {viewMode === "day" && (
                <DayWiseDashboard
                  setSelectedMonth={setSelectedMonth}
                  selectedMonth={selectedMonth}
                  selectedDate={selectedDate}
                  setSelectedDate={handleSetSelectedDate}
                  activeFilter={activeFilter}
                  vehiclesData={filteredVehiclesData}
                  onRefresh={fetchBookings}
                  onNavigateToBooking={handleNavigateToBooking}
                />
              )}
              {viewMode === "month" && (
                <MonthlyDashboard
                  selectedMonth={selectedMonth}
                  activeFilter={activeFilter}
                  vehiclesData={filteredVehiclesData}
                  onRefresh={fetchBookings}
                />
              )}
              {viewMode === "enquiry" && (
                <EnquiryDashboard
                  vehiclesData={vehiclesData}
                  selectedMonth={selectedMonth}
                  onRefresh={fetchBookings}
                  onNavigateToBooking={handleNavigateToBooking}
                />
              )}
            </Box>
          )}

          {/* Sign out, opened from the header's logout tile */}
          <LogoutConfirmDialog
            open={logoutOpen}
            onClose={() => setLogoutOpen(false)}
          />
        </Box>
      )}
    </>
  );
}
